// Amazon Region Configuration for Frontend
export const AMAZON_REGIONS = {
  'north-america': {
    name: 'North America',
    countries: [
      { code: 'US', name: 'United States', flag: '🇺🇸' },
      { code: 'CA', name: 'Canada', flag: '🇨🇦' },
      { code: 'MX', name: 'Mexico', flag: '🇲🇽' },
      { code: 'BR', name: 'Brazil', flag: '🇧🇷' }
    ]
  },
  'europe': {
    name: 'Europe',
    countries: [
      { code: 'UK', name: 'United Kingdom', flag: '🇬🇧' },
      { code: 'DE', name: 'Germany', flag: '🇩🇪' },
      { code: 'FR', name: 'France', flag: '🇫🇷' },
      { code: 'IT', name: 'Italy', flag: '🇮🇹' },
      { code: 'ES', name: 'Spain', flag: '🇪🇸' },
      { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
      { code: 'SE', name: 'Sweden', flag: '🇸🇪' },
      { code: 'PL', name: 'Poland', flag: '🇵🇱' }
    ]
  },
  'far-east': {
    name: 'Far East',
    countries: [
      { code: 'JP', name: 'Japan', flag: '🇯🇵' },
      { code: 'AU', name: 'Australia', flag: '🇦🇺' },
      { code: 'SG', name: 'Singapore', flag: '🇸🇬' }
    ]
  }
};

export const getAllCountries = () => {
  return Object.values(AMAZON_REGIONS).flatMap(region => 
    region.countries.map(country => ({
      ...country,
      region: region.name
    }))
  );
};

export const getRegionByCountry = (countryCode) => {
  for (const [regionKey, region] of Object.entries(AMAZON_REGIONS)) {
    const country = region.countries.find(c => c.code === countryCode);
    if (country) {
      return { ...region, key: regionKey, country };
    }
  }
  return null;
};
